/**
 * What her colour means, said in words.
 *
 * This started life as a catalogue pool and should not have. A pool is for
 * things she *says* — they rotate, they must not repeat inside a fortnight,
 * and the variety is the point. This is not that. It is the legend for the
 * tint on the presence strip, and a legend that rewords itself every morning
 * is not a legend; it is a second thing to learn.
 *
 * There is a second, duller reason. The tell is pinned per day, and `plain` is
 * the mood most days are, so a three-line pool would be drawn nine or ten
 * times in a fourteen-day window — well past the point where the no-repeat
 * machinery has anything left to protect, and a `POOL_META` entry claiming
 * otherwise would have been a lie in the one table that is supposed to keep
 * the catalogue honest.
 *
 * So: one clause per tone, fixed. The liveliness lives in the colour and the
 * breathing, which do change; the caption under them holds still.
 */

import type { PresenceTone } from '@gramas/shared'

/** Under the greeting, in her colour. Lower case, no full stop: a caption. */
export const TONE_TELL: Readonly<Record<PresenceTone, string | null>> = {
  // Nothing to explain on an ordinary day, and a caption that says "ordinary"
  // every morning would be the app narrating its own lack of news.
  plain: null,
  astri: 'trečiadienis',
  proud: 'savaitė laikosi',
  gloomy: 'lapkritis',
  festive: 'šventė',
  neglected: 'seniai kalbėjomės',
  loyal: 'šiandien nesijuokiu',
}

/**
 * The longer form, for her own panel — where somebody has opened a sheet on
 * purpose and a two-word caption would be an anticlimax.
 */
export const TONE_STATUS: Readonly<Record<PresenceTone, string>> = {
  plain: 'Būsena: įprasta',
  astri: 'Būsena: trečiadienis',
  proud: 'Būsena: patenkinta ir to nepripažįsta',
  gloomy: 'Būsena: lapkritis',
  festive: 'Būsena: šventinė',
  neglected: 'Būsena: laukia',
  loyal: 'Būsena: šalia',
}
